import ForgotPasswordStep from './ForgotPasswordStep';

export default ForgotPasswordStep;
